import type { User } from 'oidc-client-ts';
import { OpenIdLoginPage } from '../pages/login/OpenIdLoginPage';
import { UnauthenticatedAppShell } from './UnauthenticatedAppShell';

export type UnauthenticatedAppOIDCProps = {
    login: () => void;
    silentLogin: (onSuccess?: (user: User) => void) => void;
};

export const UnauthenticatedAppOIDC = (props: UnauthenticatedAppOIDCProps) => {
    return (
        <UnauthenticatedAppShell>
            <OpenIdLoginPage {...props} />
        </UnauthenticatedAppShell>
    );
};
